import { MODULE_NAME } from 'features/biller/constants';

import { SLICE_NAME } from './constants';

export const selectShopifyTierDowngradeError = state =>
  state.getIn([MODULE_NAME, SLICE_NAME]).shopifyTierDowngradeError;

export const selectShopifyUrl = state =>
  state.getIn([MODULE_NAME, SLICE_NAME]).shopifyUrl;
